var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscribeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.338 6.72c0 2.151-1.69 3.895-3.775 3.895S6.787 8.87 6.787 6.72c0-2.151 1.69-3.895 3.776-3.895 2.085 0 3.775 1.744 3.775 3.895zM3.956 15.651c0-2.15 1.69-3.894 3.775-3.894h5.663c2.085 0 3.775 1.744 3.775 3.894 0 2.151-1.69 3.895-3.775 3.895H7.73c-2.085 0-3.775-1.744-3.775-3.895z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribeBlack);
export default __webpack_public_path__ + "static/media/subscribeBlack.91e1f16c4b5b281460b30d71bc4d74a1.svg";
export { ForwardRef as ReactComponent };